module.exports = "<app-visit  \n[requestType]=\"requestType\" \n[title]=\"title\"></app-visit>\n"